angular.module('leanlaw').controller('CustomerEditCtrl', ['$scope', '$q', '$stateParams', 'leanLawApi', '$state', 'accountingService', function ($scope, $q, $stateParams, leanLawApi, $state, accountingService) {
  if (!$stateParams.client) {
    return $state.go('^');
  }
  $scope.loading = true;
  $scope.saving = false;
  $scope.data = {
    clients: [],
    customer: $stateParams.client,
    subcustomer: $stateParams.matter,
    client: null,
    newClient: {},
    matter: null,
    newMatter: {}
  };
  accountingService.verify(true).catch(() => {
    $state.go('^');
  });
  leanLawApi.listClients({
    scope: 'all'
  }).then(list => {
    $scope.data.clients = list.clients;
    $scope.loading = false;
    if ($scope.data.customer.client) {
      $scope.data.client = _.find($scope.data.clients, client => client.id == $scope.data.customer.client.id);
    }
    if ($scope.data.subcustomer && $scope.data.subcustomer.matter) {
      $scope.data.matter = _.find($scope.data.client.matters, matter => matter.id == $scope.data.subcustomer.matter.id);
    }
  });
  $scope.save = function () {
    if (!$scope.data.client && !$scope.data.newClient.create) {
      $scope.addAlert('danger', `Please pick a client or a ${$scope.me.terms.matter}`);
      return;
    }
    $scope.saving = true;
    let done = $q.reject();

    // optionally create client
    let clientPromise = $q.resolve($scope.data.client);
    if ($scope.data.newClient.create) {
      // duplicated in import.ctrl, move to service

      const {
        customer
      } = $scope.data;
      const clientCreate = angular.copy(customer.contact);
      clientCreate.method = "QBO Import";
      _.extend(clientCreate, customer.contact.address); // in customer.contact, address is an object. In clientCreate is is flat

      clientPromise = leanLawApi.createClient({
        body: clientCreate
      });
    }
    if (!$scope.data.matter && !$scope.data.newMatter.create) {
      // associate with client only
      done = clientPromise.then(client => leanLawApi.updateClientAccounting({
        id: client.id,
        body: {
          accounting: {
            id: $scope.data.customer.id
          }
        }
      }));
    } else {
      // optionally create matter
      let matterPromise = $q.resolve($scope.data.matter);
      if ($scope.data.newMatter.create) {
        matterPromise = clientPromise.then(client => leanLawApi.createMatter({
          body: {
            method: 'QBO Import',
            name: $scope.data.subcustomer.name,
            client: {
              id: client.id
            }
          }
        }));
      }

      // associate with matter
      const update = {
        accounting: {
          id: $scope.data.subcustomer.id,
          client: {
            id: $scope.data.customer.id
          }
        }
      };
      done = matterPromise.then(matter => leanLawApi.updateMatterAccounting({
        id: matter.id,
        body: update
      }));
    }
    done.then(() => {
      accountingService.refresh();
      $state.go('^', {}, {
        reload: true
      });
    }).catch(err => {
      $scope.addAlert('danger', err.body.message);
      $scope.saving = false;
    });
  };
}]);